//#region frontend/lib/trial-placeholder.js
var PLACEHOLDER_HANDLE = "happy-howl-subscription";
var placeholderData = null;
async function loadPlaceholderData() {
	if (!placeholderData) {
		const res = await fetch(`/products/${PLACEHOLDER_HANDLE}.js`);
		if (!res.ok) return null;
		placeholderData = await res.json();
	}
	return placeholderData;
}
function weeksFrom(text) {
	const match = (text || "").match(/(\d+)\s*weeks?/i);
	return match ? match[1] : null;
}
async function resolvePlaceholderItem(cadenceText) {
	const data = await loadPlaceholderData();
	if (!data) return null;
	const weeks = weeksFrom(cadenceText);
	let plan;
	let variant;
	if (weeks) {
		const rx = new RegExp(`\\b${weeks}\\s*weeks?\\b`, "i");
		for (const group of data.selling_plan_groups || []) {
			plan = group.selling_plans?.find((p) => rx.test(p.name));
			if (plan) break;
		}
		variant = data.variants?.find((v) => rx.test(v.title));
	}
	plan = plan || data.selling_plan_groups?.[0]?.selling_plans?.[0];
	variant = variant || data.variants?.[0];
	if (!plan || !variant) return null;
	return {
		id: variant.id,
		selling_plan: plan.id,
		quantity: 1,
		properties: { _placeholder: "true" }
	};
}
function addPlaceholderLine(item) {
	return fetch("/cart/add.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		},
		body: JSON.stringify({ items: [item] })
	});
}
function changeLine(key, quantity) {
	return fetch("/cart/change.js", {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json"
		},
		body: JSON.stringify({
			id: key,
			quantity
		})
	});
}
function needsPlaceholder(items) {
	const hasTrial = items.some((item) => item.properties && item.properties._trial === "true");
	const realSubs = items.filter((item) => item.selling_plan_allocation && !(item.properties && item.properties._placeholder === "true"));
	return hasTrial && realSubs.length === 1;
}
async function reconcileTrialPlaceholder() {
	const cart = await fetch("/cart.js").then((r) => r.json()).catch(() => null);
	if (!cart) return;
	const items = cart.items || [];
	const placeholders = items.filter((item) => item.properties && item.properties._placeholder === "true");
	if (!needsPlaceholder(items)) {
		for (const p of placeholders) await changeLine(p.key, 0);
		return;
	}
	if (placeholders.length === 0) {
		const item = await resolvePlaceholderItem(items.find((item) => item.properties && item.properties._trial === "true").properties._after_trial_cadence);
		if (item) await addPlaceholderLine(item);
		return;
	}
	for (let i = 1; i < placeholders.length; i++) await changeLine(placeholders[i].key, 0);
	if (placeholders[0].quantity !== 1) await changeLine(placeholders[0].key, 1);
}
//#endregion
export { resolvePlaceholderItem as i, needsPlaceholder as n, reconcileTrialPlaceholder as r, addPlaceholderLine as t };
